import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';

export default function StudentInfo({ student = {} }) {
  const { t } = useTranslation(['landlord']);

  return (
    <div className="student-info__wrapper">
      <div className="longtail-booking-details__block">
        <label className="longtail-booking-details__block-title">
          {t('landlord.long_tail.booking_details.label.student_info')}
        </label>
        <div>
          <div className="longtail-booking-details__block-row-container">
            <Row gutter={50} className="longtail-booking-details__block-row">
              <Col span={12} className="longtail-booking-details__block-col">
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.passport_first_name', {
                    value: student && student.passportFirstName ? student.passportFirstName : '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.passport_last_name', {
                    value: student?.passportLastName ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.student_external_id', {
                    value: student?.systemId ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.gender', {
                    value: student?.gender ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.email', {
                    value: student?.emailAddress ?? '-',
                  })}
                </p>
              </Col>
              <Col span={12} className="longtail-booking-details__block-col">
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.passport_middle_name', {
                    value: student && student.passportLastName ? student.passportMiddleName : '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.student_internal_id', {
                    value: student?.referenceId ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t(
                    'landlord.long_tail.booking_details.label.student_info.student_source_region',
                    {
                      value: student?.sourceRegion ?? '-',
                    },
                  )}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.date_of_birth', {
                    value: student?.dateOfBirth ?? '-',
                  })}
                </p>

                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.mobile', {
                    value: student?.phoneNumber ?? '-',
                  })}
                </p>
              </Col>
            </Row>
          </div>

          <div className="longtail-booking-details__block-row-container">
            <Row gutter={50} className="longtail-booking-details__block-row">
              <Col span={12} className="longtail-booking-details__block-col">
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.destination_country', {
                    value: '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t(
                    'landlord.long_tail.booking_details.label.student_info.destination_university',
                    {
                      value:
                        student?.destinationUniversity ??
                        t(
                          'landlord.long_tail.booking_details.label.student_info.default_university',
                        ),
                    },
                  )}
                </p>
              </Col>
              <Col span={12} className="longtail-booking-details__block-col">
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.destination_city', {
                    value: '-',
                  })}
                </p>
              </Col>
            </Row>
          </div>

          <div className="longtail-booking-details__block-row-container">
            <Row gutter={50} className="longtail-booking-details__block-row">
              <Col span={12} className="longtail-booking-details__block-col">
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.country', {
                    value: student?.country ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.city', {
                    value: student?.city ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.address', {
                    value: student?.addressLines ?? '-',
                  })}
                </p>
              </Col>
              <Col span={12} className="longtail-booking-details__block-col">
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.state', {
                    value: student?.state ?? '-',
                  })}
                </p>
                <p className="longtail-booking-details__line">
                  {t('landlord.long_tail.booking_details.label.student_info.postal', {
                    value: student?.postalCode ?? '-',
                  })}
                </p>
                {/* <p className="longtail-booking-details__line">
                  {student?.postalCode
                    ? t('landlord.long_tail.booking_details.label.student_info.address_line_2', {
                        value: '*********',
                      })
                    : '-'}
                </p> */}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}
